import { useRef, useState } from 'react'

const DEBOUNCE_MS = 500

interface CashInputFieldProps {
  onChange: (value: number | null) => void
  recordedCashEur: string | null
}

export function CashInputField({ onChange, recordedCashEur }: CashInputFieldProps) {
  const [raw, setRaw] = useState<string>('')
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value
    setRaw(value)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      if (value === '') {
        onChange(null)
        return
      }
      const num = Number(value)
      if (Number.isFinite(num) && num >= 0) {
        onChange(num)
      }
    }, DEBOUNCE_MS)
  }

  const recorded = recordedCashEur === null ? null : Number(recordedCashEur)
  const hint =
    recorded === null
      ? null
      : recorded > 0
        ? `Leer = erfasster Bestand: ${recorded.toLocaleString('de-DE')} €`
        : 'kein Cash erfasst'

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col gap-1 md:flex-row md:items-center md:gap-3">
        <label htmlFor="cash-input" className="tracked-caps text-[10px] text-faint md:text-xs">
          Aktueller Cash-Bestand
        </label>
        <input
          id="cash-input"
          type="number"
          inputMode="decimal"
          min={0}
          step={1}
          value={raw}
          onChange={handleChange}
          placeholder="0"
          className="w-full border border-hairline bg-void px-3 py-2 text-right font-mono text-sm text-ink transition-colors focus:border-bernstein focus:outline-none md:w-40"
        />
        <span className="font-mono text-xs text-faint">€</span>
      </div>
      {hint && <span className="font-mono text-[10px] text-faint">{hint}</span>}
    </div>
  )
}
